function FarmerHomepage(){
    return <div>FarmerHomepage</div>;
}
export default FarmerHomepage;